module.exports = "/images/PrivacyPolicy.svg?96b318aafdd3872b8d1a1c52cc4c3239";